var _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1934 7.25586C8.84192 7.25586 5.19859 12.4889 3.75823 15.1456C3.40681 15.7938 3.2311 16.1178 3.25046 16.6266C3.26982 17.1354 3.47615 17.4553 3.88883 18.095C5.5877 20.7288 9.7016 26.054 15.1934 26.054C20.6852 26.054 24.7991 20.7288 26.498 18.095C26.9106 17.4553 27.117 17.1354 27.1363 16.6266C27.1557 16.1178 26.98 15.7937 26.6286 15.1456C25.1882 12.4889 21.5449 7.25586 15.1934 7.25586Z",
    stroke: "#3B4B53",
    strokeWidth: 1.85827
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.193,
    cy: 16.6551,
    rx: 3.64806,
    ry: 4.02816,
    stroke: "#3B4B53",
    strokeWidth: 1.85827
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEye);
export default __webpack_public_path__ + "static/media/ic_eye.1c98d79f61c4a083e120609377a115d9.svg";
export { ForwardRef as ReactComponent };